<!-- header config -->
<div *ngIf="expansionStyle == 'header'">
    <div class="row">
        <div class="col col-sm-12"><div class="c-title--subsection ">Header Label</div></div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="headerLabel">Label</label></div>
                <input id="headerLabel"
                    cclFormInput
                    type="text"
                    class="c-form-group__input c-input--required"
                    [(ngModel)]="headerConfig.label"
                    maxlength="100"
                />
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="headerLabelColor">Label Color</label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="headerConfig.label_color"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="headerLabelColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="headerConfig.label_color"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': headerConfig.label_color }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="headerBackgroundColor">Background Color</label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="headerConfig.background"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="headerBackgroundColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="headerConfig.background"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': headerConfig.background }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label"><label for="fontStyle">Font Style</label></div>
                <ccl-simple-select formId="fontStyle"
                    [listOfItems]="sharedService.fontStyles"
                    (valueChange)="headerConfig.fontStyle = $event.value"
                    [value]="headerConfig.fontStyle"
                    [bindValue]="'id'"
                    [bindLabel]="'label'"
                    [isClearable]="false"
                ></ccl-simple-select>
                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>
</div>

<!-- drawer control config -->
<div *ngIf="expansionStyle == 'drawer-control'">
    <div class="row">
        <div class="col-sm-6">
            <div class="form-group">
                <div class="c-form-group__label">
                    <label for="iconOption">Icon Option</label>
                </div>
                <ccl-simple-select formId="iconOption"
                    [listOfItems]="iconList"
                    (valueChange)="drawerControlConfig.icon = $event.value"
                    [value]="drawerControlConfig.icon"
                    [bindValue]="'class'"
                    [bindLabel]="'label'"
                ></ccl-simple-select>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="iconColor">Icon Color</label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="drawerControlConfig.color"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="iconColor"
                        cclFormInput
                        type="text"
                        [(ngModel)]="drawerControlConfig.color"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': drawerControlConfig.color }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="c-form-group">
                <div class="c-form-group__label">
                    <label for="iconBackground">Background</label>
                </div>
                <div
                    class="input-group"
                    [(colorPicker)]="drawerControlConfig.background"
                    [cpAlphaChannel]="'disabled'"
                    [cpOutputFormat]="'hex'"
                    [cpPosition]="'left'"
                >
                    <input id="iconBackground"
                        cclFormInput
                        type="text"
                        [(ngModel)]="drawerControlConfig.background"
                        class="c-form-group__input form-control"
                    />

                    <div class="input-group-append">
                        <span
                            class="c-color-picker input-group-text"
                            [ngStyle]="{ 'background-color': drawerControlConfig.background }"
                            >&nbsp;</span
                        >
                    </div>
                </div>

                <div class="c-form-group__hint">&nbsp;</div>
            </div>
        </div>
    </div>
</div>

